import CompensationFeeCards from "./CompensationFeeCards";

export default CompensationFeeCards;
